import React from 'react';
import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/react/24/solid';

/**
 * Renders the button used to toggle the visibility of the chat sidebar.
 * 
 * @param {object} props - Component props.
 * @param {boolean} props.sidebarOpen - Current visibility state of the sidebar.
 * @param {function} props.setSidebarOpen - Function to update the sidebar visibility state.
 */
export default function SidebarToggle({ sidebarOpen, setSidebarOpen }) {
    return (
        <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="absolute -left-8 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-l-md shadow-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 z-10" // Added hover and focus states
            aria-label={sidebarOpen ? "Close sidebar" : "Open sidebar"}
            aria-expanded={sidebarOpen}
        >
            {sidebarOpen ? (
                <ChevronRightIcon className="h-6 w-6 text-gray-600" aria-hidden="true" />
            ) : (
                <ChevronLeftIcon className="h-6 w-6 text-gray-600" aria-hidden="true" />
            )}
        </button>
    );
}